import { Component } from '@angular/core';

import { NgbTimepicker } from '@ng-bootstrap/ng-bootstrap';
import { FieldBaseComponent } from '@shared/components/forms/components/field-base';
import { FormFieldErrorComponent } from '@shared/components/forms/components/form-field-error/form-field-error.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-form-time',
  styleUrls: ['form-time.component.scss'],
  templateUrl: 'form-time.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgbTimepicker,
    FormFieldErrorComponent,
  ],
})
export class FormTimeComponent extends FieldBaseComponent {}
